import { userActions } from '_actions/user.actions';

let intervalId = undefined;


const uiMonitor = store => next => action => {
    const prevState = store.getState();
    let result = next(action);
    const nextState = store.getState();


    // TODO - the following comparison looks for _any_ change under the ui branch of state
    // we may want to limit this down to only certain sub-areas of interest below the ui branch.


    if (JSON.stringify(prevState.ui) !== JSON.stringify(nextState.ui)) {
        if (intervalId !== undefined) {
            clearInterval(intervalId);
            intervalId = undefined;
        }
        if (!nextState.ui.errorReport.lastErno && !nextState.ui.errorReport.submitting) {
            intervalId = setInterval(() => tick(store, userActions.saveSession), 10000);
        }
    }

    return result
}


function tick(store, saveSession) {
    if (localStorage.getItem('user') && !store.getState().ui.session.loading) {
        store.dispatch(saveSession());
    }
    if (intervalId !== undefined) {
        clearInterval(intervalId);
        intervalId = undefined;
    }
}


export default uiMonitor